import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  ClickAwayListener,
  InputAdornment,
  Paper,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import axios from "axios";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import CandidateDetails from "./candidateDetails";
import { generate_filter_condition } from "../utiles/filter";
import { onGlobalFliterFunc } from "../utiles/onFilterChange";
import AdvanceFilter from "./advanceFilter";
import Cookies from "js-cookie";
import NewAddCandidate from "./NewAddCandidate";
import DynamicDataGrid from "./dynamicDataGrid";

const Applicants = (props) => {
  const PermissionStatus = useSelector((state) => state.user.permissions);
  const addCandidatePermission = PermissionStatus["100"];
  const { id } = useParams();
  const [candidatedrawerflag] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [applicants, setApplicantsdata] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [isApplicanOpen, setApplicanOpen] = useState(false);
  const [isDrawerOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [candidateid, setCandidateId] = useState([]);
  const [checkboxSelected, setcheckboxSelected] = useState(true);
  const [verifiedstatus, setverifiedstatus] = useState("");
  const [refreshagain, setrefreshagain] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [comment, setComment] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isCheckboxSelected, setIsCheckboxSelected] = useState(false);
  const [opennew, setOpennew] = React.useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [rerenderKey, setRerenderKey] = useState(0);
  const [searchTermPrev, setSearchTermPrev] = useState("");
  const [queryOptions, setQueryOptions] = useState({});
  const [filterOptions, filtersetQueryOptions] = React.useState({
    filterModel: null,
  });
  const [candidateIdDate, setCandidateIdDate] = useState([]);
  const [showLoader, setShowLoader] = useState(true);
  const [FilterHitting, setFilterHitting] = useState(false);
  const [advanceFilter, setAdvanceFilter] = useState(false);
  const [question, setQuestion] = useState([]);
  const [quesAnsArrayFilter, setQuesAnsArrayFilter] = useState([]);
  const [current, setCurrent] = useState([]);
  const [textFields, setTextFields] = useState({});
  const [radioValues, setRadioValues] = useState({});
  const [operatorValues, setOperatorValues] = useState({});
  const [checkboxValues, setCheckboxValues] = useState({});
  const [checkedCount, setCheckedCount] = useState(0);
  const [isReset, setIsReset] = useState(false);
  const [selectedCount, setSelectedCount] = useState(0);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [candidateList, setCandidateList] = useState([]);
  const [createdby, setCreatedby] = useState("");
  const [newData, setNewData] = useState([]);
  const [cancelData, setCancelData] = useState(false);
  const [username, setUsername] = useState("");

  // ── Filter dropdown state ──
  const [filterDropdownOpen, setFilterDropdownOpen] = useState(false);
  const [createdBySelected, setCreatedBySelected] = useState([]);

  const getUserData = async () => {
    const user_id = localStorage.getItem("user_id");
    const res = await axios.get(`active-users/${user_id}`, {
      headers: {
        authorization:
          Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
      },
    });
    setCandidateList(res.data.message);
    setUsername("Select User Name");
  };

  useEffect(() => {
    getUserData();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchTerm);
    }, 400);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  // ── Apply Created By filter on selection change ──
  const handleCreatedByChange = (event, value) => {
    setCreatedBySelected(value);
    const usernames = value.map((item) => item.name);
    if (usernames.length > 0) {
      setCreatedby(
        generate_filter_condition(
          "and candidate_info.entered_by",
          "isAnyOf",
          usernames,
        ),
      );
    } else {
      setCreatedby("");
    }
  };

  const handleSelectionData = (event, value, reason) => {
    setSelectedOptions(value);
    setSelectedCount(value.length);
    const usernames = value?.map((item) => item.name);
    const filterCondition = generate_filter_condition(
      "and candidate_info.entered_by",
      "isAnyOf",
      usernames,
    );
    if (usernames.length > 0) setCreatedby(filterCondition);
    else setCreatedby("");
    if (reason === "clear") {
      setCreatedby("");
      setCancelData(true);
    }
    if (reason === "removeOption") setCancelData(true);
  };

  const handleCheckboxChange = (e, qId, index) => {
    const checked = e.target.checked;
    setCheckboxValues((prev) => ({ ...prev, [qId]: checked }));
    let tempArr = [...quesAnsArrayFilter];
    tempArr[index].isChecked = checked;
    if (checked) {
      setQuesAnsArrayFilter(tempArr);
    } else {
      tempArr[index].ans_text = "";
      tempArr[index].errorText = null;
      setTextFields((prev) => ({ ...prev, [qId]: "" }));
      setRadioValues((prev) => ({ ...prev, [qId]: "" }));
      setQuesAnsArrayFilter(tempArr);
    }
    setCheckedCount(quesAnsArrayFilter.filter((item) => item.isChecked).length);
  };

  const handleAdvanceFilterOpen = () => {
    setNewData(selectedOptions);
    let mytemp = current.map((q) => ({ ...q }));
    const updatedValues = {},
      updatedText = {},
      updatedRadioValues = {},
      updatedOperator = {};
    mytemp.forEach((q) => {
      updatedText[q.question_id] = q.ans_text;
      updatedRadioValues[q.question_id] = q.ans_text;
      updatedOperator[q.question_id] = q.operator;
      if (q.isChecked !== undefined) updatedValues[q.question_id] = q.isChecked;
    });
    setOperatorValues((prev) => ({ ...prev, ...updatedOperator }));
    setRadioValues((prev) => ({ ...prev, ...updatedRadioValues }));
    setTextFields((prev) => ({ ...prev, ...updatedText }));
    setCheckboxValues((prev) => ({ ...prev, ...updatedValues }));
    setQuesAnsArrayFilter([...mytemp]);
    if (cancelData) setSelectedCount(newData.length);
    setAdvanceFilter(true);
  };

  const handleAdvanceFilterClose = () => {
    setAdvanceFilter(false);
    selectedOptions.length > 0 || cancelData
      ? setSelectedOptions(newData)
      : setSelectedOptions([]);
  };

  const handleFilterReset = () => {
    setTextFields({});
    setRadioValues({});
    setCheckboxValues({});
    setCheckedCount(0);
    const a = quesAnsArrayFilter.map((q) => ({
      type_id: q.type_id,
      question_id: q.question_id,
      ans_text: "",
      errorText: null,
      operator: "=",
      isChecked: false,
    }));
    setQuesAnsArrayFilter(a);
    setIsReset(true);
    setCurrent(a);
    setAdvanceFilter(false);
    setFilterHitting(false);
    setrefreshagain(!refreshagain);
    setSelectedOptions([]);
    setCreatedby("");
  };

  const validate = () => {
    let isValid = true;
    let updateArray = [...quesAnsArrayFilter];
    updateArray.forEach((item) => {
      if (item.type_id === 2 && item.isChecked) {
        if (item.ans_text === "") {
          item.errorText = "This field is required";
          isValid = false;
        } else if (item.ans_text.length > 12) {
          item.errorText = "Maximum 12 digits allowed";
          isValid = false;
        } else item.errorText = null;
      } else if (item.type_id === 3 && item.isChecked) {
        if (item.ans_text === "") {
          item.errorText = "Please select an option";
          isValid = false;
        } else item.errorText = null;
      } else item.errorText = null;
    });
    setQuesAnsArrayFilter(updateArray);
    return isValid;
  };

  const handleAdvanceFilterApply = () => {
    setAdvanceFilter(!validate());
    let error = 0;
    let updateArray = [...quesAnsArrayFilter];
    updateArray.forEach((item) => {
      if (item.isChecked) {
        if (item.type_id === 2 && item.ans_text === "") {
          error = 1;
          item.errorText = "This field is required";
        } else if (item.type_id === 3 && item.ans_text === "") {
          error = 1;
          item.errorText = "Please select an option";
        }
      }
    });
    if (!error) {
      let mytemp = quesAnsArrayFilter.map((q) => ({ ...q }));
      const countChecked = quesAnsArrayFilter.filter(
        (item) => item.isChecked,
      ).length;
      setCheckedCount(
        selectedOptions.length || newData.length > 0
          ? countChecked + 1
          : countChecked,
      );
      setCurrent([...mytemp]);
      setFilterHitting(true);
      setrefreshagain(!refreshagain);
    }
  };

  const handleSortModelChange = React.useCallback((sortModel) => {
    setQueryOptions({ sortModel: [...sortModel] });
  }, []);

  const openDialog = () => setIsDialogOpen(true);
  const closeDialog = () => setIsDialogOpen(false);
  const handleSnackbarOpen = (message) => {
    setSnackbarMessage(message);
    setOpenSnackbar(true);
  };
  const handleSnackbarClose = () => setOpenSnackbar(false);

  const onFilterChange = React.useCallback((filterModel) => {
    const respFilterData = onGlobalFliterFunc(
      filterModel,
      `and concat(u.first_name, ' ', u.last_name)`,
    );
    if (respFilterData) filtersetQueryOptions(respFilterData);
  }, []);

  useEffect(() => {
    setShowLoader(true);
    let payload = {
      jobId: id,
      isShortlisted: 1,
      pageSize: paginationModel.pageSize,
      filterCriteria: createdby
        ? createdby
        : filterOptions.filterCondition
          ? filterOptions.filterCondition
          : "",
    };
    if (queryOptions.sortModel?.length > 0) {
      payload.sortField = queryOptions.sortModel[0].field;
      payload.sortBy = queryOptions.sortModel[0].sort;
    }
    axios
      .post(
        `job-applicants/${searchTermPrev && searchTermPrev !== debouncedSearch ? 1 : paginationModel.page + 1}${debouncedSearch ? "?search=" + debouncedSearch : ""}`,
        payload,
        {
          headers: {
            authorization:
              Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
          },
        },
      )
      .then((response) => {
        console.log("API response:", response.data.message);
        const filteredApplicants = response.data.message.data.filter(
          (a) => a.id !== null,
        );
        console.log("filtered:", filteredApplicants);
        setApplicantsdata(filteredApplicants);
        setShowLoader(false);
        setSearchTermPrev(debouncedSearch); // ✅ debouncedSearch
        setTotalCount(response.data.message.page);
        setIsReset(false);
      })
      .catch(() => {
        setShowLoader(false);
        setApplicantsdata([]);
      });
  }, [
    isDrawerOpen,
    open,
    refreshagain,
    isDialogOpen,
    paginationModel,
    queryOptions,
    debouncedSearch,
    isApplicanOpen,
    filterOptions,
    createdby,
  ]);

  const HandleRowClick = (row) => {
    setverifiedstatus(row.isVerified);
    setSelectedRowData(row);
    setApplicanOpen(true);
  };

  const filteredApplicants = applicants.filter((row) =>
    Object.values(row).some((value) =>
      value?.toString().toLowerCase().includes(searchTerm.toLowerCase()),
    ),
  );

  const handleSelection = (params) => {
    const rowData = filteredApplicants.filter((e) => params.includes(e.id));
    const newdata = rowData.map((e) => ({
      id: e.id,
      date_modified: e.date_modified,
    }));
    setcheckboxSelected(true);
    setIsCheckboxSelected(!!params.length);
    setCandidateId(params);
    setCandidateIdDate(newdata);
  };

  const handleOnClose = () => {
    setApplicanOpen(false);
    setOpennew((prev) => !prev);
  };

  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", height: "100%", gap: 2 }}
    >
      {/* ── Toolbar ── */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* Left: Title */}
        <Typography
          sx={{ fontSize: "16px", fontWeight: 700, color: "#1a2e4a" }}
        >
          Applicants
        </Typography>

        {/* Right: Search + Add Candidates + Filter */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          {/* Search */}
          <TextField
            size="small"
            type="search"
            placeholder="Search"
            variant="outlined"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" sx={{ color: "#667085" }} />
                </InputAdornment>
              ),
              sx: {
                borderRadius: "8px",
                fontSize: "0.875rem",
                height: "32px",
                backgroundColor: "background.paper",
              },
            }}
            sx={{ width: "200px" }}
          />

          {/* ADD CANDIDATES — simple button */}
          {addCandidatePermission?.add === 1 && (
            <NewAddCandidate
              isAddToJob={true}
              Job_id={id}
              setrefreshagain={setrefreshagain}
            />
          )}

          {/* ── Filter button with Created By dropdown ── */}
          <Box sx={{ position: "relative" }}>
            <Button
              variant="outlined"
              size="small"
              onClick={() => setFilterDropdownOpen((prev) => !prev)}
              startIcon={<img src="/assets/filter.svg" alt="" />}
              sx={{
                borderColor:
                  createdBySelected.length > 0 ? "#3b82f6" : "#d1d5db",
                color: createdBySelected.length > 0 ? "#3b82f6" : "#374151",
                backgroundColor: "#fff",
                textTransform: "none",
                fontWeight: 500,
                fontSize: "14px",
                borderRadius: "8px",
                px: 1.5,
                gap: 0.5,
                "&:hover": {
                  borderColor: "#9ca3af",
                  backgroundColor: "#f9fafb",
                },
                "& .MuiButton-startIcon": {
                  marginRight: "0",
                },
              }}
            >
              FILTER
              {/* Count badge */}
              {createdBySelected.length > 0 && (
                <Box
                  sx={{
                    background: "#3b82f6",
                    color: "#fff",
                    borderRadius: "50%",
                    minWidth: 18,
                    height: 18,
                    fontSize: "11px",
                    fontWeight: 700,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    px: 0.4,
                  }}
                >
                  {createdBySelected.length}
                </Box>
              )}
            </Button>

            {/* Created By dropdown panel */}
            {filterDropdownOpen && (
              <ClickAwayListener
                onClickAway={() => setFilterDropdownOpen(false)}
              >
                <Paper
                  elevation={4}
                  sx={{
                    position: "absolute",
                    top: "calc(100% + 6px)",
                    right: 0,
                    width: 300,
                    borderRadius: "10px",
                    overflow: "hidden",
                    zIndex: 1300,
                    border: "1px solid #e5e7eb",
                  }}
                >
                  {/* Header */}
                  <Box
                    sx={{
                      px: 2,
                      py: 1.2,
                      borderBottom: "1px solid #f1f5f9",
                      background: "#f8fafc",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "13px",
                        fontWeight: 600,
                        color: "#1a2e4a",
                      }}
                    >
                      Created By
                    </Typography>
                  </Box>

                  {/* Searchable multi-select with checkboxes */}
                  <Box sx={{ p: 1.5 }}>
                    <Autocomplete
                      multiple
                      disableCloseOnSelect
                      options={candidateList || []}
                      value={createdBySelected}
                      onChange={handleCreatedByChange}
                      getOptionLabel={(option) => option.name || ""}
                      isOptionEqualToValue={(option, value) =>
                        option.name === value.name
                      }
                      renderOption={(props, option, { selected }) => (
                        <li
                          {...props}
                          style={{ padding: "4px 8px", cursor: "pointer" }}
                        >
                          <Checkbox
                            icon={
                              <CheckBoxOutlineBlankIcon sx={{ fontSize: 18 }} />
                            }
                            checkedIcon={<CheckBoxIcon sx={{ fontSize: 18 }} />}
                            checked={selected}
                            sx={{
                              p: 0.5,
                              mr: 1,
                              color: "#9ca3af",
                              "&.Mui-checked": { color: "#3b82f6" },
                            }}
                          />
                          <Typography
                            sx={{ fontSize: "13px", color: "#374151" }}
                          >
                            {option.name}
                          </Typography>
                        </li>
                      )}
                      renderTags={(value, getTagProps) =>
                        value.map((option, index) => (
                          <Chip
                            key={index}
                            label={option.name}
                            size="small"
                            {...getTagProps({ index })}
                            sx={{
                              fontSize: "11px",
                              height: "22px",
                              background: "#eff6ff",
                              color: "#3b82f6",
                            }}
                          />
                        ))
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder={
                            createdBySelected.length === 0
                              ? "Search users..."
                              : ""
                          }
                          size="small"
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "8px",
                              fontSize: "13px",
                              "& fieldset": { borderColor: "#e5e7eb" },
                            },
                          }}
                        />
                      )}
                      ListboxProps={{
                        sx: { maxHeight: 200, fontSize: "13px" },
                      }}
                    />
                  </Box>

                  {/* Footer */}
                  <Box
                    sx={{
                      px: 1.5,
                      pb: 1.5,
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: 1,
                    }}
                  >
                    <Button
                      size="small"
                      onClick={() => {
                        setCreatedBySelected([]);
                        setCreatedby("");
                        setrefreshagain((prev) => !prev);
                      }}
                      sx={{
                        fontSize: "12px",
                        color: "#6b7280",
                        textTransform: "none",
                      }}
                    >
                      Clear
                    </Button>
                    <Button
                      size="small"
                      variant="contained"
                      onClick={() => {
                        setrefreshagain((prev) => !prev);
                        setFilterDropdownOpen(false);
                      }}
                      sx={{
                        fontSize: "12px",
                        textTransform: "none",
                        background: "#3b82f6",
                        borderRadius: "6px",
                        "&:hover": { background: "#2563eb" },
                      }}
                    >
                      Apply
                    </Button>
                  </Box>
                </Paper>
              </ClickAwayListener>
            )}

            {/* AdvanceFilter dropdown — inside position:relative Box, appears below filter button */}
            <AdvanceFilter
              advanceFilter={advanceFilter}
              handleAdvanceFilterOpen={handleAdvanceFilterOpen}
              handleAdvanceFilterClose={handleAdvanceFilterClose}
              handleAdvanceFilterApply={handleAdvanceFilterApply}
              handleFilterReset={handleFilterReset}
              question={question}
              setQuestion={setQuestion}
              textFields={textFields}
              radioValues={radioValues}
              operatorValues={operatorValues}
              checkboxValues={checkboxValues}
              quesAnsArrayFilter={quesAnsArrayFilter}
              selectedCount={selectedCount}
              selectedOptions={selectedOptions}
              handleSelectionData={handleSelectionData}
              handleCheckboxChange={handleCheckboxChange}
              candidateList={candidateList}
              username={username}
              setCurrent={setCurrent}
            />
          </Box>
        </Box>
      </Box>

      {/* ── Table ── */}
      <Box
        sx={{
          height: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          overflowY: "hidden",
        }}
      >
        <DynamicDataGrid
          rows={applicants}
          loading={showLoader}
          showCheckbox={false}
          name={"Shortlisted"}
          onRowSelection={HandleRowClick}
          totalRows={totalCount}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
        />
      </Box>

      <CandidateDetails
        isOpen={isApplicanOpen}
        onClose={handleOnClose}
        setApplicanOpen={setApplicanOpen}
        setRerenderKey={setRerenderKey}
        selectedRowData={selectedRowData}
        candidatedrawerflag={candidatedrawerflag}
        Shortlisted={true}
        issearchnavbar={true}
        questionrequired={props.questionrequired}
        responsehide={props.questionrequired ? true : false}
        Jobstatus={props.status}
      />

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={
            snackbarMessage === "Candidate Status Changed Successfully"
              ? "success"
              : "error"
          }
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Applicants;
